'use strict';

angular.module('aq.admin.productDesign')
    .controller('MainCtrl', function ($scope, $state) { });
